export default __webpack_public_path__ + "static/media/score.41434bd4.svg";